import { useLang } from '@/i18n';
import styles from './index.module.scss';

const ExclusiveSection = () => {
    const { t } = useLang('theProduct.ExclusiveSection');

    return (
        <section className={styles.exclusiveSection}>
            <div className="text-container">
                <p className="label">{t('label')}</p>
                <h2 className="title">{t('title')}</h2>
            </div>
            <div className="text-container content">
                <h3 className="h3">{t(`sec1_title`)}</h3>
                <p className="p">{t(`sec1_desc`)}</p>
                <p className="line" />
                <h3 className="h3">{t(`sec2_title`)}</h3>
                <p className="p">{t(`sec2_desc`)}</p>
                {/* <p className="line" />
                <h3 className="h3">{t(`sec3_title`)}</h3>
                <p className="p">{t(`sec3_desc`)}</p> */}
            </div>
        </section>
    );
};

export default ExclusiveSection;
